import axios from 'axios';
import { history } from "../../index";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import i18n from 'i18next';

const notify = (message) => toast(message);

if (process.env.NODE_ENV !== 'production')
    axios.defaults.baseURL = 'https://localhost:7231/';
else
    axios.defaults.baseURL = 'https://api.mychf.ch/';


axios.interceptors.request.use((config) => {       
    const user = JSON.parse(window.localStorage.getItem('loginStore'));
    let token = '';

    if (user && user.accountInfo?.token)
        token = user.accountInfo?.token;

    config.headers.Authorization = `Bearer ${token}`;   
    return config;

}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => response, async (error) => {    
    if (error.code === "ERR_NETWORK") {
        toast.error('Network error');
        throw error;
    }

    const { status, data, config } = error.response;
    

    if (status === 404)
        toast.error(i18n.t('urlDoesNotExist'));

    if (status === 401) {
        window.localStorage.removeItem("loginStore");
        window.location.reload();
    }
        
        //resetSession();
        //history.push('login');
    /*if (status === 400) {
        if (config.method === 'get' && data.errors.hasOwnProperty('id'))
            alert("400");

        if (config.method === 'post') {
            toast.error(error.response.data.errors.error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                progress: undefined,
            });
        }
    }*/

    /*if (status === 500)
        toast.error(error.response.data.errors);*/
    if (status === 500 || status == 400) {
        var blobbedResponse = error.request.responseType === 'blob';
        if (blobbedResponse) {
            var blobData = JSON.parse(await data.text());
            if (blobData.title === "Business validation error") {
                showToastWithParam(blobData?.message);
            } else {
                toast.error(i18n.t("errorOcurred"));
            }            
        } else {
               
            switch (data.title) {

                case "Business validation error":                    
                    showToastWithParam(data?.message);
                    throw data?.message;
                    break;
                /*case "One or more validation errors occurred.":
                    
                    break;*/
                case "Command validation error":
                    toast.error(data?.errors?.join(','))
                    break;
                default:
                    toast.error(i18n.t("errorOcurred"));
                    break;
            }
        }
    }

    throw error.response;
});

const showToastWithParam = (message) => {
    var hasParam = message?.indexOf("_") > -1;
    var parts = message?.split("_");
    var errorKey = hasParam ? parts[0] : message;
    toast.error(i18n.t(errorKey || "errorOcurred", hasParam ? { param: parts[1] } : null));
}
const responseBody = (response) => response.data;
const getFilename = (headers) => headers?.['content-disposition']?.split(';')?.find(n => n.includes('filename='))?.replace('filename=', '')?.replace(/"/g, "")?.trim();
const getUTF8Filename = (headers) => decodeURIComponent(headers?.['content-disposition']?.split(';')?.find(n => n.includes('filename*=UTF-8'))?.replace('filename*=UTF-8', '')?.replace("''", "")?.trim())

const downloadResponse = (response) => new Promise(
    (resolve, reject) => {
        resolve({
            bytes: response.data, filename: getFilename(response?.headers), utf_filename: getUTF8Filename(response?.headers)
        })
    })

const sleep = (ms) => (response) =>
    new Promise(resolve => setTimeout(() => resolve(response), ms));

export const requests = {
    get: (url, params) => axios.get(url, { params: params }).then(sleep(1000)).then(responseBody),
    download: (url) => axios.get(url, { responseType: 'blob' }).then(downloadResponse),
    post: (url, body) => axios.post(url, body).then(responseBody),
    put: (url, body) => axios.put(url, body).then(sleep(1000)).then(responseBody),
    delete: (url) => axios.delete(url).then(sleep(1000)).then(responseBody),
};